"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetNeedWorlds = useGetNeedWorlds;
var react_1 = require("react");
var api_1 = require("../api");
var util_1 = require("../util");
var sentry_1 = require("../sentry");
var i18n_1 = __importDefault(require("../i18n"));
function getNeedWorlds(state) {
    return __awaiter(this, void 0, void 0, function () {
        var worldsArray, worldProfilesArray, worlds_1, missingWorldIds, now_1, needDetailWorldIds, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(!state.needWorldFetching && state.needWorldIds.length)) return [3 /*break*/, 5];
                    if (!state.needWorldIds[0].length) {
                        state.dispatchNeedWorldIds({ operation: "shift" });
                        return [2 /*return*/];
                    }
                    state.setNeedWorldFetching(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, (0, api_1.fetchWorlds)(state.needWorldIds[0])];
                case 2:
                    worldsArray = _a.sent();
                    return [4 /*yield*/, (0, api_1.fetchWorldProfiles)(worldsArray.map(function (w) { return w.id; }))];
                case 3:
                    worldProfilesArray = _a.sent();
                    worlds_1 = (0, util_1.joinWorldAndProfiles)(worldsArray, worldProfilesArray);
                    missingWorldIds = state.needWorldIds[0].filter(function (id) { return !worlds_1[id]; });
                    now_1 = new Date();
                    needDetailWorldIds = worldsArray
                        .filter(function (world) { return (0, util_1.isWorldNeedDetailFetch)(world, now_1); })
                        .map(function (world) { return world.id; });
                    state.addWorlds(worlds_1);
                    if (state.logined)
                        state.dispatchMissingWorldIds({ operation: "push", ids: missingWorldIds.concat(needDetailWorldIds) });
                    state.dispatchNeedWorldIds({ operation: "shift" });
                    state.setNeedWorldFetching(false);
                    return [3 /*break*/, 5];
                case 4:
                    error_1 = _a.sent();
                    (0, sentry_1.captureException)(error_1);
                    state.incrementErrorCount();
                    alert("".concat(i18n_1.default.world, "\n").concat(error_1));
                    state.dispatchNeedWorldIds({ operation: "shift" });
                    state.setNeedWorldFetching(false);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    });
}
function useGetNeedWorlds(state) {
    (0, react_1.useEffect)(function () {
        getNeedWorlds(state);
    }, [
        state.needWorldFetching,
        state.needWorldIds.toString(), // useEffect(requestAnimationFrame)ごとにpushかshiftか決まっているので一度に増えて減ってというケースはないはず?
    ]);
}
